import { TestCycle } from '@qality/common-model';

export default {
  isAnyIssueLinkedToAnyExecution: (testCycle: TestCycle) => {
    return testCycle.testCases.some((testCase) => {
      return testCase.issuesLinkedToExecution?.length > 0;
    });
  },
};
